'use client';

import { useTranslations } from 'next-intl';
import { cardVariants } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { buildKeyDates } from '@/app/[locale]/event/[eventId]/libs/keyDates';
import { EventKeyDates } from './EventKeyDates';

interface EventDetailsCardProps {
  event: {
    start_date: string;
    end_date: string;
    registration_opens?: string | null;
    registration_closes?: string | null;
    min_participants?: number | null;
    max_participants?: number | null;
    entry_fee?: number | null;
    currency?: string | null;
  };
  locale: string;
  /** True when the mobile sticky register bar is rendered and already shows the price. */
  feeInRegisterBar?: boolean;
}

export function EventDetailsCard({
  event,
  locale,
  feeInRegisterBar = false,
}: EventDetailsCardProps) {
  const t = useTranslations('Event');

  const steps = buildKeyDates(event, new Date());

  const items = [
    event.entry_fee
      ? {
          label: t('details.entryFee'),
          value: `${event.entry_fee} ${event.currency || 'TWD'}`,
        }
      : null,
  ].filter(Boolean) as Array<{ label: string; value: string }>;

  return (
    <section className={cn(cardVariants.base, 'p-4 md:p-6')}>
      <EventKeyDates steps={steps} locale={locale} />

      {/* When the mobile register bar is shown it carries the price; otherwise the fee stays visible. */}
      {items.map((item, i) => (
        <p key={i} className={cn('text-muted mt-3 text-xs', feeInRegisterBar && 'hidden md:block')}>
          {item.label} <span className="text-foreground font-medium">{item.value}</span>
        </p>
      ))}
    </section>
  );
}
